// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__1He-Q","rotation":"Loader_rotation__pqhtw"};